import Search from '/../core/views/pages/search';
export default Search;